import { cached_ranks } from '../getRank';

export default function (measure, year) {
  return Object.entries(cached_ranks).filter((e) => {
    const [iso, vals] = e;
    return Number.isInteger(vals[measure][year]);
  }).length;
}
